import Vue from "vue";
import "../common.js";
import ConsentForm from "../components/ConsentForm";

import "../css/pages/consent.scss";

Vue.config.productionTip = false;

document.addEventListener("DOMContentLoaded", () => {
  new Vue({
    render: h => h(ConsentForm),
  }).$mount(".js-consent-form");
});
